import { render } from "./ManageTransfers.vue?vue&type=template&id=3bd92789"
import script from "./ManageTransfers.vue?vue&type=script&lang=js"
export * from "./ManageTransfers.vue?vue&type=script&lang=js"

import "./ManageTransfers.vue?vue&type=style&index=0&id=3bd92789&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__